<template lang="pug">
.accordion(:class="{ 'is-open': expand }")
  .accordion-ttl(@click="toggle()")
    slot(name="title")
  .accordion-body
    slot(name="body")
</template>

<script>
export default {
  props: {
    open: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      expand: false
    }
  },
  mounted() {
    this.expand = this.open
  },
  methods: {
    toggle() {
      this.expand = !this.expand
    }
  }
}
</script>
